"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.equal = exports.areValuesEqual = exports.eqv = exports.eq = void 0;
const sExpression_1 = require("../sExpression");
exports.eq = {
    type: 'procedure',
    variant: 'BuiltInProcedure',
    name: 'eq?',
    callSignature: {
        style: 'fixed-args',
        numParams: 2
    },
    body: (args) => {
        const lhs = args[0];
        const rhs = args[1];
        if ((lhs.type === 'number' && rhs.type === 'number') ||
            (lhs.type === 'boolean' && rhs.type === 'boolean') ||
            (lhs.type === 'string' && rhs.type === 'string') ||
            (lhs.type === 'symbol' && rhs.type === 'symbol')) {
            return sExpression_1.makeBool(lhs.value === rhs.value);
        }
        else if (lhs.type === 'empty list' && rhs.type === 'empty list') {
            return sExpression_1.makeBool(true);
        }
        else if ((lhs.type === 'procedure' && rhs.type === 'procedure') ||
            (lhs.type === 'pair' && rhs.type === 'pair')) {
            return sExpression_1.makeBool(lhs === rhs);
        }
        else {
            return sExpression_1.makeBool(false);
        }
    }
};
exports.eqv = Object.assign(Object.assign({}, exports.eq), { name: 'eqv?' });
const areValuesEqual = (lhs, rhs) => {
    if ((lhs.type === 'number' && rhs.type === 'number') ||
        (lhs.type === 'boolean' && rhs.type === 'boolean') ||
        (lhs.type === 'string' && rhs.type === 'string') ||
        (lhs.type === 'symbol' && rhs.type === 'symbol')) {
        return lhs.value === rhs.value;
    }
    else if (lhs.type === 'empty list' && rhs.type === 'empty list') {
        return true;
    }
    else if (lhs.type === 'procedure' && rhs.type === 'procedure') {
        return lhs === rhs;
    }
    else if (lhs.type === 'pair' && rhs.type === 'pair') {
        return exports.areValuesEqual(lhs.head, rhs.head) && exports.areValuesEqual(lhs.tail, rhs.tail);
    }
    else {
        return false;
    }
};
exports.areValuesEqual = areValuesEqual;
exports.equal = {
    type: 'procedure',
    variant: 'BuiltInProcedure',
    name: 'equal?',
    callSignature: {
        style: 'fixed-args',
        numParams: 2
    },
    body: (args) => sExpression_1.makeBool(exports.areValuesEqual(args[0], args[1]))
};
//# sourceMappingURL=equal.js.map